import { Box, Button, Collapse, Divider, Icon, Typography } from '@mui/material';
import { useState } from 'react';
import { useLazyMallIsFooter } from '@/store/lazyMallStore';
import MallIcon from './components/MallIcon';
import MallColor from '@/helpers/MallColor';
import { useNavigate, useParams } from 'react-router-dom';
import { getMallPathWithProductGroupId, isLogined, MallBusinessInfoType } from '@/services/mallUser.service';
import { useLoginFormDialogStore } from '@/store/loginFormDialogStore';
import { FooterInfoDataType } from '@/router';

function Footer({ footerInfo }) {
    const [open, setOpen] = useState(false);
    const isFooter = useLazyMallIsFooter();
    const handleClick = () => {
        setOpen(!open);
    };
    const { mallBusinessInfo, shopName } = footerInfo

    return (
        <>
            {isFooter && (
                <Box>
                    {/* <MallInfo
                        mallName={shopName}
                        ceoName={mallBusinessInfo.ownerName}
                        businessNumber={mallBusinessInfo.businessRegistrationNumber}
                        sellNumber={mallBusinessInfo.mailOrderSalesRegistrationNumber}
                        customerCenterNumber={mallBusinessInfo.customerCenterNumber}
                    /> */}

                    <MallInfo
                        mallName={'플로잉'}
                        ceoName={'오석환'}
                        businessNumber={'650-86-03029'}
                        sellNumber={'제 2024-서울강동-1600 호'}
                        customerCenterNumber={'02-474-2866'}
                    />
                    <Divider />

                    <Box
                        display={'flex'}
                        onClick={handleClick}
                        bgcolor={`${MallColor['box-bg-white']}`}
                        padding={'3% 5% 3%'}
                        gap="2%"
                        sx={{
                            '& :hover': {
                                // cursor: 'pointer',
                            },
                        }}
                    >
                        <Typography variant='h5'>2022 Flowing Corp.</Typography>
                        <Typography variant='h5' onClick={(e) => {
                            e.stopPropagation()
                            window.open('https://terms.flowing.tel/terms.html')
                        }}>이용약관</Typography>
                        <Typography variant='h5' onClick={(e) => {
                            e.stopPropagation()
                            window.open('https://terms.flowing.tel/privacy.html')
                        }}>개인정보처리방침</Typography>
                        <Box flexGrow={1} />
                        {/* {open ? <MallIcon iconName='up-arrow' size='nav'/> : <MallIcon iconName='down-arrow' size='nav'/>} */}
                    </Box>
                    <Collapse in={false}>
                        <Box>
                            <Typography variant='h5' margin="2% 6%" lineHeight={'1.3rem'}>
                                (주)플로잉스페이스 대표 : 오석환
                                <br />
                                사업자등록번호 : 650-86-03029
                                <br />
                                통신판매번호 : 제 2024-서울강동-1600 호<br />
                                대표번호 : 070-4504-4055
                                <br />
                                주소 : 서울 강동구 길동 천호 대로 1121 일성하이츠
                                <br />
                            </Typography>
                        </Box>
                    </Collapse>

                    <Divider />
                    {/* <Box display={'flex'} bgcolor={`${MallColor['box-bg-white']}`} paddingBottom='20px'>
                        <Typography variant='h5' padding={'2% 5% 1%'}>
                            (주)플로잉스페이스는 통신판매중개자이며, 통신판매의 당사자가 아닙니다.<br/>
                            상품, 상품정보, 거래에 관한 의무와 책임은 판매자에게 있습니다.
                        </Typography>
                    </Box>
                    <Divider /> */}
                </Box>
            )}
        </>
    );
}

export default Footer;

function MallInfo({ mallName, ceoName, businessNumber, sellNumber, customerCenterNumber }) {
    const navigate = useNavigate()
    const params = useParams()
    const { setIsOpen, setPath } = useLoginFormDialogStore((state) => state.action)
    async function generatePath(): Promise<string> {
        if (!!params.path) return params.path || ''
        else {
            if (window.location.href.includes('product-details')) {
                return await getMallPathWithProductGroupId(params.productId || '').then(r => {
                    console.log('r::::', r)
                    return r
                })
            } else return ''
        }
    }
    return (
        <Box bgcolor={`${MallColor['box-bg-white']}`} sx={{ py: 2 }}>
            <Box display={'flex'} margin="0 5%" padding={'10px 0 0'}>
                <Typography variant='h2' fontWeight={500}>{mallName}</Typography>
                <Box flexGrow={1} />
                <Button
                    variant="outlined"
                    color='custom'
                    size='small'
                    onClick={async () => {
                        const path = await generatePath()
                        if (isLogined()) navigate(`/mall/${path}/inquiry`);
                        else {
                            setPath(path)
                            setIsOpen(true)
                        }
                    }}
                >
                    1:1 상담
                </Button>
                <Box width={'2%'} />
                <Button variant="outlined" color='custom' size='small' onClick={async () => {
                    const path = await generatePath()
                    navigate(`/mall/${path}/notice`)
                }}>
                    공지사항
                </Button>
                {/* <Box width={'2%'} />
                <Button variant="outlined" color='custom' size='small' onClick={() => {
                    navigate(`/mall/${params?.path}/refund-info`)
                }}>
                    교환 / 환불 안내
                </Button> */}
            </Box>
            <Box display={'flex'} margin="0 5% 0">
                <Typography variant='h5'>
                    상호명: (주)플로잉스페이스 <br />
                    대표자: {ceoName} <br />
                    사업자등록번호: {businessNumber} | 통신판매번호: {sellNumber} <br />
                    고객센터: {customerCenterNumber} <br />
                    주소 : 서울 강동구 길동 천호 대로 1121 일성하이츠
                </Typography>
            </Box>
        </Box>
    );
}